import { render, staticRenderFns } from "./Bag.vue?vue&type=template&id=86c1c5ee&scoped=true&"
import script from "./Bag.vue?vue&type=script&lang=js&"
export * from "./Bag.vue?vue&type=script&lang=js&"
import style0 from "./Bag.vue?vue&type=style&index=0&id=86c1c5ee&scoped=true&lang=css&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "86c1c5ee",
  null
  
)

export default component.exports